module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer014"
    }
  }, [_c('p', {
    staticClass: "Page-heading",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims"
  }, [_vm._v("Christina’s love for storytelling and illustrations stem from the classic fairy tales she grew up on.")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims"
  }, [_vm._v("Her whimsical outlook keeps her inner-child alive in creating funny stories adults and children can enjoy. Christina currently resides in Chandler, Indiana with her husband and a little monster.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9975d022","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781645360742_EPUB.vue
// module id = 57
// module chunks = 0